<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2">mdi-food-outline</v-icon>
      Quotes by Menu
    </v-card-title>
    <v-card-text>
      <div v-if="loading" class="text-center py-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else-if="!menus.length" class="text-center py-8 text-grey">
        No data available
      </div>
      <v-table v-else>
        <thead>
          <tr>
            <th>Menu</th>
            <th class="text-right">Quotes</th>
            <th class="text-right">%</th>
            <th style="width: 140px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="menu in menus" :key="menu.menuName">
            <td class="font-weight-medium">{{ menu.menuName }}</td>
            <td class="text-right font-weight-bold">{{ menu.count }}</td>
            <td class="text-right text-medium-emphasis">{{ menu.percentage }}%</td>
            <td>
              <v-progress-linear
                :model-value="Number(menu.percentage)"
                color="primary"
                height="6"
                rounded
              ></v-progress-linear>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="font-weight-bold">Total</td>
            <td class="text-right font-weight-bold">{{ total }}</td>
            <td colspan="2"></td>
          </tr>
        </tfoot>
      </v-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { statisticsService } from '../services';

export default {
  name: 'MenuBreakdownTable',
  props: {
    startDate: { type: [String, Date], required: true },
    endDate: { type: [String, Date], required: true },
  },
  data() {
    return {
      loading: false,
      menus: [],
      total: 0,
    };
  },
  watch: {
    startDate: { immediate: true, handler() { this.loadData(); } },
    endDate: { handler() { this.loadData(); } },
  },
  methods: {
    toYmd(d) {
      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const day = String(dt.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    async loadData() {
      this.loading = true;
      try {
        const response = await statisticsService.getQuotesByMenu({
          startIso: this.toYmd(this.startDate),
          endIso: this.toYmd(this.endDate),
        });
        if (response?.success) {
          this.menus = response.data.menus;
          this.total = response.data.total;
        } else {
          this.menus = [];
          this.total = 0;
        }
      } catch (e) {
        console.error('Failed to load menu breakdown', e);
        this.menus = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
